export const USERS_OPERATIONS_ROUTE_PATHS = {
  usersOperations: '/users-operations',
};
